import * as React from 'react';

import MonthlyReport56 from './MonthlyReport56';

export const monthlyReport56 = () => <MonthlyReport56 />;

export default {
    title: 'Illustration|MonthlyReport56',
    component: MonthlyReport56,
    parameters: {
        notes: "`import MonthlyReport56 from 'box-ui-elements/es/illustration/MonthlyReport56';`",
    },
};
